// extracted by mini-css-extract-plugin
export default {"container":"InstructionsInput_container__i49Hh","wrapper":"InstructionsInput_wrapper__U1KVT"};